var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H68C69.933 0.5 71.5 2.067 71.5 4V44C71.5 45.933 69.933 47.5 68 47.5H4C2.06701 47.5 0.5 45.933 0.5 44V4Z",
    fill: "white",
    stroke: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5005 32.4657H16.8272L13.3227 19.1224C13.1564 18.5086 12.8032 17.966 12.2837 17.7103C10.9872 17.0676 9.55854 16.5561 8 16.2981V15.7844H15.5284C16.5674 15.7844 17.3467 16.5561 17.4765 17.4523L19.2948 27.0773L23.9659 15.7844H28.5093L21.5005 32.4657ZM31.1069 32.4657H26.6934L30.3277 15.7844H34.7412L31.1069 32.4657ZM40.4511 20.406C40.581 19.5075 41.3602 18.9938 42.2694 18.9938C43.698 18.8648 45.2543 19.1228 46.5531 19.7633L47.3323 16.1717C46.0336 15.658 44.6049 15.4 43.3084 15.4C39.0247 15.4 35.9076 17.7106 35.9076 20.9175C35.9076 23.3571 38.1155 24.638 39.6741 25.4097C41.3602 26.1792 42.0096 26.6929 41.8797 27.4623C41.8797 28.6165 40.581 29.1303 39.2845 29.1303C37.7259 29.1303 36.1674 28.7455 34.741 28.1028L33.9617 31.6966C35.5203 32.3371 37.2064 32.5951 38.7649 32.5951C43.5681 32.7218 46.5531 30.4134 46.5531 26.9486C46.5531 22.5854 40.4511 22.3296 40.4511 20.406ZM62.0003 32.4657L58.4959 15.7844H54.7317C53.9524 15.7844 53.1732 16.2981 52.9134 17.0676L46.4241 32.4657H50.9675L51.8744 30.0283H57.4569L57.9764 32.4657H62.0003ZM55.381 20.2769L56.6775 26.5638H53.0432L55.381 20.2769Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3c0945c808ca0204fd6ce287ced2f8a3.svg";
export { ForwardRef as ReactComponent };